import { render, staticRenderFns } from "./TestSpeaking.vue?vue&type=template&id=1e40b13e&scoped=true"
import script from "./TestSpeaking.vue?vue&type=script&lang=js"
export * from "./TestSpeaking.vue?vue&type=script&lang=js"
import style0 from "./TestSpeaking.vue?vue&type=style&index=0&id=1e40b13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e40b13e",
  null
  
)

export default component.exports